<template>
	<div>
		<a-card :bordered="false" class="cache-card">
			<div slot="title" class="cache-card-title">缓存管理</div>
			<p class="cache-desc">
				点击「更新缓存」将向消息队列下发刷新任务，由JAVA服务端异步完成刷新。
			</p>
			<a-spin :spinning="pageLoading">
				<div v-if="!pageLoading && items.length === 0" class="cache-empty">暂无缓存项</div>
				<ul v-else class="cache-list">
					<li v-for="item in items" :key="item.cacheKey" class="cache-row">
						<div class="cache-row-main">
							<span class="cache-title">{{ item.title }}</span>
							<code class="cache-key">{{ item.cacheKey }}</code>
						</div>
						<a-button
							type="link"
							size="small"
							class="cache-action"
							:loading="refreshingKey === item.cacheKey"
							@click="onRefresh(item.cacheKey)"
							v-has="'/system/cacheRefresh'"
						>
							<a-icon type="reload" />
							更新缓存
						</a-button>
					</li>
				</ul>
			</a-spin>
		</a-card>
	</div>
</template>

<script>
import { cacheItems, cacheRefresh } from '@/api/system/cache';

export default {
	data() {
		return {
			pageLoading: false,
			items: [],
			refreshingKey: '',
		};
	},
	created() {
		this.loadItems();
	},
	methods: {
		loadItems() {
			this.pageLoading = true;
			cacheItems()
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						this.items = [];
						return;
					}
					const list = (res.data.items || []).map((row) => ({
						cacheKey: row.cacheKey,
						title: row.title,
					}));
					this.items = list;
				})
				.catch(() => {
					this.$message.error('网络异常');
					this.items = [];
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
		onRefresh(cacheKey) {
			this.refreshingKey = cacheKey;
			cacheRefresh(cacheKey)
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '发送失败');
						return;
					}
					this.$message.success('已下发刷新任务');
				})
				.catch(() => {
					this.$message.error('网络异常');
				})
				.finally(() => {
					this.refreshingKey = '';
				});
		},
	},
};
</script>

<style lang="less" scoped>
.cache-card {
	/deep/ .ant-card-head {
		border-bottom: none;
		padding-bottom: 0;
		min-height: auto;
	}
}

.cache-card-title {
	font-size: 16px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.88);
}

.cache-desc {
	margin: 0 0 16px;
	padding: 12px 14px;
	font-size: 13px;
	line-height: 1.65;
	color: rgba(0, 0, 0, 0.55);
	background: #f5f5f5;
	border-radius: 8px;
	border-left: 3px solid #1890ff;
}

.cache-empty {
	padding: 24px;
	text-align: center;
	color: #8c8c8c;
	font-size: 14px;
}

.cache-list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.cache-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 14px;
	border: 1px solid #f0f0f0;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
	transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.cache-row:hover {
	background-color: #fafafa;
	border-color: #e6e6e6;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.cache-row-main {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;
	min-width: 0;
	flex: 1;
}

.cache-title {
	font-size: 14px;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.88);
	line-height: 1.4;
}

.cache-title::after {
	content: '\FF1A';
	color: rgba(0, 0, 0, 0.45);
	font-weight: 400;
}

.cache-key {
	display: inline-block;
	max-width: 100%;
	padding: 2px 8px;
	margin: 0;
	font-size: 12px;
	line-height: 1.5;
	color: #595959;
	background: #f5f5f5;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
	word-break: break-all;
}

.cache-action {
	flex-shrink: 0;
	padding: 0 4px;
	font-weight: 500;
}

.cache-action /deep/ .anticon {
	margin-right: 4px;
}

@media (max-width: 768px) {
	.cache-list {
		grid-template-columns: 1fr;
	}
}
</style>
